import { AxiosGet, AxiosPost } from "../useApi";


export function GetScheduleItineraries() {
    const route = 'schedule-itineraries';
    return AxiosGet(route);
}

export function GetScheduleItineraryByScheduleId(scheduleId) {
    const route = 'schedule-itineraries/by-schedule/';
    return AxiosGet(route, scheduleId);
}

export function GetScheduleItineraryByScheduleItineryIdId(scheduleItineryId) {
    const route = 'schedule-itineraries/by-id/';
    return AxiosGet(route, scheduleItineryId);
}

export function PostScheduleItineraryChanges(data) {
    const route = 'schedule-itineraries/handle-change/';

    return AxiosPost(route, null, data);
} 

